import { render, staticRenderFns } from "./echarts2.vue?vue&type=template&id=0fc1437a"
import script from "./echarts2.vue?vue&type=script&lang=js"
export * from "./echarts2.vue?vue&type=script&lang=js"
import style0 from "./echarts2.vue?vue&type=style&index=0&id=0fc1437a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc1437a')) {
      api.createRecord('0fc1437a', component.options)
    } else {
      api.reload('0fc1437a', component.options)
    }
    module.hot.accept("./echarts2.vue?vue&type=template&id=0fc1437a", function () {
      api.rerender('0fc1437a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/echarts2.vue"
export default component.exports